import { ChevronLeft, ChevronRight, CircleHelp, Clock, Search } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useChat } from "@/lib/chat";
import { HealthPill } from "./HealthPill";

export const TopBar = () => {
  const { workspace } = useAuth();
  const { setModal } = useChat();
  const navigate = useNavigate();
  return (
    <header className="tc-topbar" data-testid="top-bar">
      <div className="tc-topbar__left">
        <div className="tc-topbar__nav">
          <button className="tc-topbar__navbtn" title="Back" onClick={() => navigate(-1)} data-testid="nav-back-button"><ChevronLeft size={18} /></button>
          <button className="tc-topbar__navbtn" title="Forward" onClick={() => navigate(1)} data-testid="nav-forward-button"><ChevronRight size={18} /></button>
          <button className="tc-topbar__navbtn" title="History" onClick={() => setModal({ type: "search" })} data-testid="nav-history-button"><Clock size={16} /></button>
        </div>
        <HealthPill />
      </div>
      <button className="tc-topbar__search" onClick={() => setModal({ type: "search" })} data-testid="top-search-button">
        <Search size={14} />
        <span>Search {workspace?.name || "Total Chat"}</span>
      </button>
      <div className="tc-topbar__right">
        <button className="tc-topbar__help" title="Help" onClick={() => setModal({ type: "help" })} data-testid="help-button"><CircleHelp size={20} /></button>
      </div>
    </header>
  );
};
